<template>
  <Grid columns="two">
    <slot />
  </Grid>
</template>
